<template>
  <div class="employee">
    <CCard class="card-table-emloyee">
      <CRow class="row-mobile">
        <CCol sm="3">
          <div class="form-group">
            <label>{{ $t("commons.label_start_date") }}</label>
            <DatePicker
              :propsDate="searchData.startDate"
              v-on:emitDate="startDate"
              :key="componentKey"
            />
          </div>
        </CCol>
        <CCol sm="3">
          <div class="form-group">
            <label>{{ $t("commons.label_end_date") }}</label>
            <DatePicker
              :propsDate="searchData.endDate"
              v-on:emitDate="endDate"
              :key="componentKey"
            />
          </div>
        </CCol>
        <CCol sm="3">
          <div class="form-group">
            <label>{{ $t("commons.label_approve_person") }}</label>
            <CInput
              v-model="searchData.approvePerson"
              :placeholder="
                this.$t('placeholder.label_approve_person_over_time_request')
              "
              v-on:keyup.enter="search"
            />
          </div>
        </CCol>
        <CCol sm="3">
          <div class="form-group">
            <label>{{ $t("commons.label_status") }}</label>
            <select
              class="form-control"
              v-model="searchData.status"
              @change="search"
            >
              <option value="0">
                {{ $t("employee.select_option") }}
              </option>
              <option value="1">{{
                $t("commons.label_status_sabbatical_leave_request_1")
              }}</option>
              <option value="2">{{
                $t("commons.label_status_sabbatical_leave_request_2")
              }}</option>
              <option value="3">{{
                $t("commons.label_status_sabbatical_leave_request_3")
              }}</option>
            </select>
          </div>
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="12" class="btn-search text-center">
          <CButton class="btn-search-employee" @click.prevent="search">
            {{ $t("button.label_employee_btn_search") }}
          </CButton>
          <CButton class="btn-reset" @click="resetForm"
            >{{ $t("button.label_action_reset") }}
          </CButton>
        </CCol>
      </CRow>
    </CCard>
    <CCard class="employee-table">
      <CCardBody>
        <div class="option-table">
          <div class="form-group">
            <select
              class="form-control select-per-page"
              v-model="searchData.itemsPerPage"
              @change="search"
            >
              <option
                v-for="(item, index) in listItemsPerPage"
                :value="item"
                :key="index"
                >{{ item }}</option
              >
            </select>
          </div>
          <template
            v-if="
              sabbaticalLeaveRequests.data &&
                sabbaticalLeaveRequests.data.length > 0
            "
          >
            <div class="show-text-table">
              {{ $t("commons.label_text_show") }}
              {{ searchData.paginate.from }}
              {{ $t("commons.label_text_to") }}
              {{ searchData.paginate.to }}
              {{ $t("commons.label_text_of") }}
              {{ searchData.paginate.totalRecord }}
              {{ $t("commons.label_text_entries") }}
            </div>
          </template>
          <template v-else>
            <div class="show-text-table">
              {{ $t("commons.label_text_show") }}
              {{ searchData.paginate.from }}
              {{ searchData.paginate.to }}
              {{ searchData.paginate.totalRecord }}
              {{ $t("commons.label_text_entries") }}
            </div>
          </template>
        </div>
        <div class="table-responsive">
          <table class="table">
            <thead>
              <tr>
                <th>#</th>
                <th
                  class="text-center cl-pointer"
                  @click="sortByColumn(columnSort.date)"
                >
                  {{ $t("commons.label_created_at") }}
                  <span class="icon-sort">
                    <CIcon
                      name="cil-caret-bottom"
                      :class="classStatusSort(columnSort.date)"
                    ></CIcon>
                  </span>
                </th>
                <th
                  class="text-center cl-pointer"
                  @click="sortByColumn(columnSort.start_time)"
                >
                  {{ $t("employee.label_employee_date_start") }}
                  <span class="icon-sort">
                    <CIcon
                      name="cil-caret-bottom"
                      :class="classStatusSort(columnSort.start_time)"
                    ></CIcon>
                  </span>
                </th>
                <th
                  class="text-center cl-pointer"
                  @click="sortByColumn(columnSort.end_time)"
                >
                  {{ $t("employee.label_employee_date_end") }}
                  <span class="icon-sort">
                    <CIcon
                      name="cil-caret-bottom"
                      :class="classStatusSort(columnSort.end_time)"
                    ></CIcon>
                  </span>
                </th>
                <th
                  class="text-center cl-pointer"
                  @click="sortByColumn(columnSort.number_days_off)"
                >
                  {{ $t("sabbatical-leave-request.label_times_leave") }}
                  <span class="icon-sort">
                    <CIcon
                      name="cil-caret-bottom"
                      :class="classStatusSort(columnSort.number_days_off)"
                    ></CIcon>
                  </span>
                </th>
                <th>{{ $t("commons.label_status_approval") }}</th>
                <th scope="col">
                  {{ $t("commons.label_sabbatical_leave_type") }}
                </th>
                <th>{{ $t("commons.label_status") }}</th>
                <th scope="col" class="min-w-180">
                  {{ $t("commons.label_employee_action") }}
                </th>
              </tr>
            </thead>
            <tbody>
              <template
                v-if="
                  sabbaticalLeaveRequests.data &&
                    sabbaticalLeaveRequests.data.length > 0
                "
              >
                <tr
                  v-for="(item, index) in sabbaticalLeaveRequests.data"
                  :key="index"
                >
                  <th scope="row">
                    {{
                      (sabbaticalLeaveRequests.current_page - 1) *
                        sabbaticalLeaveRequests.per_page +
                        index +
                        1
                    }}
                  </th>
                  <td class="text-center">
                    {{ item.updated_at | formatDate }}
                  </td>
                  <td class="text-center">
                    {{ item.start_time }} {{ item.start_date | formatDate }}
                  </td>
                  <td class="text-center">
                    {{ item.end_time }} {{ item.end_date | formatDate }}
                  </td>
                   <td class="text-center">
                    {{item.reason_type != 4 ?
                          item.number_days_off + ' ' + $t("sabbatical-leave-request.label_day") :
                          Math.round(item.number_days_off * 8 * 60) + ' ' + $t("sabbatical-leave-request.label_minute")}}
                  </td>
                  <td class="approval-status" v-if = "item.status == 2 &&
                  item.sabbatical_leave_approves[0].status == 2 && item.sabbatical_leave_approves[1]" >
                      {{ item.sabbatical_leave_approves[0].employees[0].name }} :
                        {{
                          $t(
                            `overtime.employee_approval_${item.sabbatical_leave_approves[0].status}`
                          )
                        }}
                  </td>
                  <td class="approval-status" v-else>
                    <template
                      v-if="
                        item.sabbatical_leave_approves[1] &&
                          item.sabbatical_leave_approves[0] &&
                          item.sabbatical_leave_approves[0].employee_id ===
                            item.sabbatical_leave_approves[1].employee_id
                      "
                    >
                      <ul>
                        <li>
                          <template
                            v-if="
                              parseInt(item.id) ===
                                parseInt(
                                  item.sabbatical_leave_approves[0]
                                    .sabbatical_leave_request_id
                                )
                            "
                          >
                            {{
                              item.sabbatical_leave_approves[0].employees[0]
                                .name
                            }}
                            :
                            {{
                              $t(
                                `overtime.employee_approval_${item.sabbatical_leave_approves[0].status}`
                              )
                            }}
                          </template>
                        </li>
                      </ul>
                    </template>
                    <template v-else>
                      <ul>
                        <li
                          v-for="(employeeApproval,
                          key) in item.sabbatical_leave_approves"
                          :key="key"
                        >
                          <template
                            v-if="
                              parseInt(item.id) ===
                                parseInt(
                                  employeeApproval.sabbatical_leave_request_id
                                )
                            "
                          >
                            {{ employeeApproval.employees[0].name }} :
                            {{
                              $t(
                                `overtime.employee_approval_${employeeApproval.status}`
                              )
                            }}
                          </template>
                        </li>
                      </ul>
                    </template>
                  </td>
                  <td>
                    {{
                      $t(
                        `commons.label_status_sabbatical_leave_type_${item.reason_type}`
                      )
                    }}
                  </td>
                  <td
                    class="text-center"
                    v-bind:class="
                      item.status ? 'color-status-' + item.status : ''
                    "
                  >
                    <CBadge color="secondary">{{
                      $t(
                        `commons.label_status_sabbatical_leave_request_${item.status}`
                      )
                    }}</CBadge>
                  </td>
                  <td>
                    <router-link
                      :to="{
                        path: `/sabbatical-leave-request/detail/${item.id}`
                      }"
                    >
                      <CButton color="info" variant="outline" square size="sm">
                        {{ $t("button.label_action_show") }}
                      </CButton>
                    </router-link>
                    <span class="mr-1"></span>
                    <template v-if="item.reason_type !== 4 || new Date(item.start_date).getMonth() === new Date().getMonth()">
                      <router-link
                        :to="{
                          path: `/sabbatical-leave-request/update/${item.id}`,
                          params: { id: item.id }
                        }"
                        tag="a"
                      >
                        <CButton
                          v-if="item.status === 1"
                          color="primary"
                          variant="outline"
                          square
                          size="sm"
                          >{{ $t("button.label_action_edit") }}
                        </CButton>
                      </router-link>
                      <span class="mr-1"></span>
                      <CButton
                        v-if="item.status === 1"
                        color="danger"
                        variant="outline"
                        square
                        size="sm"
                        @click="deleteItem(item.id)"
                        >{{ $t("button.label_action_delete") }}
                      </CButton>
                    </template>
                  </td>
                </tr>
              </template>
              <template v-else>
                <tr>
                  <td colspan="12" class="text-center">
                    {{ $t("table.label_data_not_found") }}
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </CCardBody>
      <CPagination
        :activePage.sync="searchData.paginate.currentPage"
        :pages="searchData.paginate.totalPage"
        @update:activePage="changePage"
        size="sm"
        align="center"
      />
    </CCard>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import DatePicker from "@/components/commons/DatePicker";
import moment from "moment";

export default {
  name: "Sabbatical",
  metaInfo() {
    return {
      title: this.$t("page_title.page_sabbatical_leave_list"),
      titleTemplate: "%s | " + this.$t("page_title.head_title")
    };
  },
  data() {
    return {
      searchData: {
        startDate: null,
        endDate: null,
        approvePerson: "",
        status: 0,
        itemsPerPage: 50,
        sortColumn: "updated_at",
        sortBy: "DESC",
        paginate: {
          from: 0,
          to: 0,
          totalPage: 0,
          path: "",
          currentPage: 1,
          totalRecord: 0,
          perPage: 0
        }
      },
      columnSort: {
        date: "updated_at",
        start_time: "start_time",
        end_time: "end_time",
        number_days_off: "number_days_off"
      },
      componentKey: 0
    };
  },
  components: {
    DatePicker
  },
  computed: {
    ...mapGetters({
      sabbaticalLeaveRequests:
        "sabbatical-leave-request/sabbaticalLeaveRequests",
      listItemsPerPage: "commons/listItemsPerPage",
      pagination: "sabbatical-leave-request/pagination"
    })
  },
  methods: {
    ...mapActions("layout", ["setLoading"]),
    startDate(data) {
      this.searchData.startDate = data;
    },
    endDate(data) {
      this.searchData.endDate = data;
    },
    async getLists() {
      if (
        this.searchData.sortBy !== "DESC" &&
        this.searchData.sortBy !== "ASC"
      ) {
        this.searchData.sortBy = "DESC";
      }
      await this.$store.dispatch(
        "sabbatical-leave-request/listSabbaticalLeaveRequests",
        {
          optionPage: this.searchData.itemsPerPage,
          currentPage: this.searchData.paginate.currentPage,
          start_date: this.searchData.startDate,
          end_date: this.searchData.endDate,
          approvePerson: this.searchData.approvePerson.toLowerCase(),
          status: parseInt(this.searchData.status),
          sortColumn: this.searchData.sortColumn,
          sortBy: this.searchData.sortBy
        }
      );
      this.searchData.paginate = this.pagination;
    },

    forceRerender() {
      this.componentKey += 1;
    },

    async search() {
      if (this.$route.fullPath !== "/sabbatical-leave-request") {
        this.clearParamUrl();
      }
      localStorage.setItem(
        "approvePersonSabbatical",
        this.searchData.approvePerson
      );
      localStorage.setItem("statusSabbatical", this.searchData.status);
      localStorage.setItem("startDateSabbatical", this.searchData.startDate);
      localStorage.setItem("endDateSabbatical", this.searchData.endDate);

      this.searchData.paginate.currentPage = 1;
      this.passParamUrl();
      this.$root.$loading.start();
      try {
        await this.getLists();
        this.$root.$loading.finish();
      } catch {
        this.$root.$loading.finish();
      }
    },

    resetForm() {
      this.searchData.startDate = this.getDateSearch().firstDay;
      this.searchData.endDate = this.getDateSearch().lastDay;
      this.searchData.approvePerson = "";
      this.searchData.status = 0;
      this.forceRerender();
      localStorage.removeItem("startDateSabbatical");
      localStorage.removeItem("endDateSabbatical");
      localStorage.removeItem("statusSabbatical");
      localStorage.removeItem("approvePersonSabbatical");
    },

    getDateSearch() {
      let date = new Date();
      let currentDay = moment(date).format("YYYY-MM-DD");
      let firstDay = "";
      if (
        moment(new Date(date.getFullYear(), date.getMonth(), 1)).format(
          "YYYY-MM-DD"
        ) <= currentDay &&
        currentDay <=
          moment(new Date(date.getFullYear(), date.getMonth(), 5)).format(
            "YYYY-MM-DD"
          )
      ) {
        firstDay = new Date(date.getFullYear(), date.getMonth() - 1, 1);
      }
      if (
        currentDay >
        moment(new Date(date.getFullYear(), date.getMonth(), 5)).format(
          "YYYY-MM-DD"
        )
      ) {
        firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
      }
      return {
        firstDay: Intl.DateTimeFormat("en-GB").format(firstDay),
        lastDay: ""
      };
    },

    checkDataParam(data) {
      return data === 0 || data === "" ? undefined : data;
    },

    passParamUrl() {
      this.$router.push({
        name: "Sabbatical leave request",
        query: {
          startDate: this.checkDataParam(
            this.convertParamsDate(this.searchData.startDate)
          ),
          endDate: this.checkDataParam(
            this.convertParamsDate(this.searchData.endDate)
          ),
          approvePerson: this.checkDataParam(
            this.searchData.approvePerson.toLowerCase()
          ),
          status: this.checkDataParam(parseInt(this.searchData.status)),
          currentPage: this.checkDataParam(
            this.searchData.paginate.currentPage
          ),
          perPage: this.checkDataParam(this.searchData.itemsPerPage),
          sortColumn: this.checkDataParam(this.searchData.sortColumn),
          sortBy: this.checkDataParam(this.searchData.sortBy)
        }
      });
    },

    clearParamUrl() {
      this.$router.push({ name: "Sabbatical leave request" });
    },

    convertParamsDate(date) {
      if (!date) return "";
      let d = moment(date, "DD/MM/YYYY");
      return d.format("DD-MM-YYYY");
    },

    reverseParamsDate(date) {
      if (!date) return "";
      let d = moment(date, "DD-MM-YYYY");
      return d.format("DD/MM/YYYY");
    },

    checkParamIsDate(date) {
      return moment(date, "DD-MM-YYYY", true).isValid();
    },

    resetParams() {
      if (this.$route.fullPath !== "/sabbatical-leave-request") {
        this.clearParamUrl();
      }
      this.searchData = {
        startDate: this.getDateSearch().firstDay,
        endDate: this.getDateSearch().lastDay,
        approvePerson: "",
        status: 0,
        itemsPerPage: 50,
        paginate: {
          from: 0,
          to: 0,
          totalPage: 0,
          path: "",
          currentPage: 1,
          totalRecord: 0,
          perPage: 0
        }
      };
    },

    changePage(page) {
      this.passParamUrl();
      this.getLists(this.searchData.itemsPerPage, page);
    },

    sortByColumn(column) {
      if (this.searchData.sortColumn != column) {
        this.searchData.sortBy = "DESC";
      }
      this.searchData.sortColumn = column;
      this.searchData.sortBy =
        this.searchData.sortBy === "DESC" ? "ASC" : "DESC";
      this.passParamUrl();
      this.getLists();
    },

    classStatusSort(column) {
      return this.searchData.sortColumn === column &&
        this.searchData.sortBy === "ASC"
        ? "sort-rotate"
        : "";
    },

    async deleteItem(sabbaticalLeaveRequestId) {
      this.$confirmModal(
        this.$t("popup.label_popup_text"),
        this.$t("popup.label_popup_title"),
        this.$t("popup.label_confirm_button"),
        this.$t("popup.label_cancel_button"),
        "danger"
      ).then(value => {
        if (value) {
          this.$store
            .dispatch(
              "sabbatical-leave-request/deleteSabbaticalLeaveRequest",
              sabbaticalLeaveRequestId
            )
            .then(() => {
              this.getLists();
              this.$toast(
                this.$t("popup.label_popup_success_text"),
                null,
                2000,
                "b-toaster-top-center",
                "success"
              );
            })
            .catch(() => {
              this.$toast(
                this.$t("popup.label_popup_error_text"),
                null,
                2000,
                "b-toaster-top-center",
                "error"
              );
            });
        }
      });
    }
  },
  created() {
    window.localStorage.clear();
    this.searchData.startDate = !localStorage.startDateSabbatical
      ? this.getDateSearch().firstDay
      : localStorage.startDateSabbatical;
    this.searchData.endDate = !localStorage.endDateSabbatical
      ? this.getDateSearch().lastDay
      : localStorage.endDateSabbatical;
    this.searchData.approvePerson = !localStorage.approvePersonSabbatical
      ? ""
      : localStorage.approvePersonSabbatical;
    if (localStorage.statusSabbatical) {
      this.searchData.status = localStorage.statusSabbatical;
    }
    if (Object.keys(this.$route.query).length !== 0) {
      let params = this.$route.query;
      params.perPage =
        this.listItemsPerPage.includes(parseInt(params.perPage)) &&
        !isNaN(params.perPage)
          ? params.perPage
          : 50;
      this.searchData = {
        startDate:
          params.startDate == undefined ||
          !this.checkParamIsDate(params.startDate)
            ? this.searchData.startDate
            : this.reverseParamsDate(params.startDate),
        endDate:
          params.endDate == undefined || !this.checkParamIsDate(params.endDate)
            ? this.searchData.endDate
            : this.reverseParamsDate(params.endDate),
        approvePerson:
          params.approvePerson == undefined
            ? this.searchData.approvePerson.toLowerCase()
            : params.approvePerson.toLowerCase(),
        status:
          params.status == undefined
            ? parseInt(this.searchData.status)
            : parseInt(params.status),
        itemsPerPage: params.perPage,
        sortColumn: params.sortColumn,
        sortBy: params.sortBy,
        paginate: {
          from: params.from,
          to: params.to,
          totalPage: parseInt(params.totalPage),
          path: this.searchData.paginate.path,
          currentPage: parseInt(params.currentPage),
          totalRecord: parseInt(params.totalRecord),
          perPage: parseInt(params.perPage)
        }
      };
    }
    this.getLists();
  },
  watch: {
    $route(to) {
      if (to.fullPath === "/sabbatical-leave-request") {
        this.resetParams();
        this.getLists();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@media screen and (min-width: 768px) and (max-width: 1024px) {
  .table {
    width: 1300px;
  }
}
.employee {
  margin: -2rem -30px 30px -30px;
  .card-table-emloyee {
    padding: 2rem 4rem 30px 4rem;
  }
  .btn-search-employee {
    background-color: #b5dbf2;
    padding: 8px;
    width: 120px;
  }
  .employee-table {
    margin: 0 50px 0 50px;
    .cl-pointer {
      cursor: pointer;
      .icon-sort {
        margin-left: 5px;
        .c-icon {
          width: 12px;
        }
        .sort-rotate {
          transform: rotate(180deg);
        }
      }
    }
  }
  .select-per-page {
    width: 70px;
  }
  .option-table {
    display: flex;
    justify-content: space-between;
  }
  .btn-search {
    margin-top: 15px;
  }
  .btn-export {
    text-align: right;
    button {
      margin-bottom: 20px;
      margin-right: 22px;
    }
  }
  .btn-reset {
    background: #e8e5e5;
    padding: 8px;
    width: 120px;
  }
  td.color-status-3 {
    span.badge.badge-secondary {
      background: #dc1313;
      color: #ffffff;
      border-radius: 10px;
    }
  }

  td.color-status-2 {
    span.badge.badge-secondary {
      background: #006400;
      color: #ffffff;
      border-radius: 10px;
    }
  }
  td.color-status-1 {
   span.badge.badge-secondary {
    background: #f58722;
    color: #ffffff;
    border-radius: 10px;
  }
}

  .approval-status {
    min-width: 250px;
  }

  .min-w-180 {
    min-width: 180px;
  }
  ul {
    list-style-type: none;
    padding-left: 0px;
    margin-bottom: 0px;

    li {
      text-align: left;
    }
  }

  th,
  td {
    vertical-align: middle !important;
  }
}

@media screen and (max-width: 740px) {
  .employee {
    margin: -2rem 0 0 0 !important;
    .employee-table {
      margin: 0 !important;
    }
    .card-table-emloyee {
      padding: 2rem 1rem 30px 1rem;
    }
  }
  .table {
    width: 1250px;
  }
  .row-mobile {
    margin-top: 25px;
  }
}
</style>
